import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { IServerSideGetRowsParams } from 'ag-grid-enterprise';
import { forkJoin } from 'rxjs';
import { AuthService } from 'src/app/services/auth.service';
import { GridService } from 'src/app/services/grid.service';
import { NoteService } from 'src/app/services/note.service';
import { UtilityService } from 'src/app/services/utility.service';

import { BaseGridComponent } from '../base-grid/base-grid.component';

@Component({
  selector: 'app-notes-grid',
  templateUrl: '../base-grid/base-grid.component.html',
  styleUrls: [
    './notes-grid.component.less',
    '../base-grid/base-grid.component.less'
  ],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class NotesGridComponent extends BaseGridComponent implements OnInit {
  constructor(
    protected override GridService: GridService,
    protected override UtilityService: UtilityService,
    protected override AuthService: AuthService,
    private NoteService: NoteService
  ) {
    super(GridService, UtilityService, AuthService);

    this.gridPrimaryKeyFieldName = 'id';
    this.gridType = 'Note';
    this.rowModelType = 'serverSide';

    this.additionalQueryData = {
      attributes: ['id'],
      User: JSON.stringify({
        UserAccountRole: {}
      })
    };

    this.ServerSideDataSource = {
      getRows: (params: IServerSideGetRowsParams) => {
        const { request } = params;

        const queryObject = this.constructGridQuery({ request });
        const countQueryObject = this.constructGridQuery(
          { request },
          { isCountQuery: true }
        );

        forkJoin([
          this.NoteService.getNotes(queryObject),
          this.NoteService.getNoteCount(countQueryObject)
        ]).subscribe({
          next: ([Notes, noteCount]) => {
            params.success({
              rowData: Notes,
              rowCount: noteCount
            });
          },
          error: (error) => {
            console.log(error);
            params.fail();
          }
        });
      }
    };
  }
}
